module.exports = __webpack_public_path__ + "img/792.6181263a.png";